const tabs = ($) => {
  /* global document, window, history, location */
  // Track the tab position in the hash and activate the correct tab when the
  // page is loaded.
  if (window.location.hash) {
    const hashVal = window.location.hash.replace('#', '');
    const $activeTab = $(`a[data-toggle="tab"][data-slug="${hashVal}"]`);
    if ($activeTab.length) {
      $activeTab.tab('show');
    }

    const $activeAccordion = $(`a[data-toggle="collapse"][data-slug="${hashVal}"]`);
    if ($activeAccordion.length) {
      $activeAccordion.closest('.panel').find('.collapse').collapse('show');
    }
  }
  $('.paragraph--type-tab, .paragraph--type-tabs').addClass('is-loaded');
  $('.region-header').on('shown.bs.dropdown', (evt) => {
    evt.target.querySelector('[type="text"]').focus();
  });
  $('a[data-toggle="tab"]').on('shown.bs.tab', (evt) => {
    const slug = $(evt.target).data('slug');
    const hashVal = window.location.hash.replace('#', '');
    if (slug !== hashVal) {
      /* eslint-disable no-restricted-globals */
      if (history.pushState) {
        history.pushState(null, null, `#${slug}`);
      } else {
        location.hash = `#${slug}`;
      }
    }
  });
  $('.view-accordion .collapse').on('shown.bs.collapse', (evt) => {
    const slug = $(evt.target).closest('.panel').find('[data-toggle="collapse"]').data('slug');
    const hashVal = window.location.hash.replace('#', '');
    if (slug !== hashVal) {
      /* eslint-disable no-restricted-globals */
      if (history.pushState) {
        history.pushState(null, null, `#${slug}`);
      } else {
        location.hash = `#${slug}`;
      }
    }
  });
  $(window).on('popstate', () => {
    const hashVal = window.location.hash.replace('#', '');
    const displayedTab = document.querySelector('.active > a[data-toggle="tab"]');
    if (displayedTab) {
      const slug = $(displayedTab).data('slug');
      if (slug !== hashVal) {
        if (hashVal) {
          const $activeTab = $(`a[data-toggle="tab"][data-slug="${hashVal}"]`);
          $activeTab.tab('show');
        } else {
          const firstTab = document.querySelector('a[data-toggle="tab"]');
          $(firstTab).click();
        }
      }
    }
  });
};

export default tabs;
